import React from "react";
import "./ComingSoon.css";

interface ComingSoonProps {
  onClose: () => void;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ onClose }) => {
  return (
    <div className="coming-soon-overlay" onClick={onClose}>
      <div className="coming-soon-container" onClick={(e) => e.stopPropagation()}>
        <button className="coming-soon-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <div className="coming-soon-content">
          <h2 className="coming-soon-title">Newsletter</h2>
          <p className="coming-soon-message">Coming Soon</p>
          <p className="coming-soon-description">
            We're working on something special. Stay tuned for updates!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;

